// Caveat: referencing vite-plugin-react-rich-svg plugin first will ensure vite types do not overlap
/// <reference types="vite-plugin-react-rich-svg/client" />
/// <reference types="vite/client" />
import React from 'react'

import radioButtonSelected from './icons/radioButtonSelected.svg?component'
import radioButton from './icons/radioButton.svg?component'
import play from './icons/play.svg?component'
import logo from './icons/logo.svg?component'
import menu from './icons/menu.svg?component'
import infoFill from './icons/infoFill.svg?component'
import dialogue from './icons/dialogue.svg?component'
import collectUserData from './icons/collectUserData.svg?component'
import user from './icons/user.svg?component'
import cog from './icons/cog.svg?component'
import ai from './icons/ai.svg?component'
import condition from './icons/condition.svg?component'
import dialogueWithTimeout from './icons/dialogueWithTimeout.svg?component'
import integration from './icons/integration.svg?component'
import message from './icons/message.svg?component'
import messageWithButtons from './icons/messageWithButtons.svg?component'
import messageWithConfirmation from './icons/messageWithConfirmation.svg?component'
import triggerAction from './icons/triggerAction.svg?component'
import sendEmail from './icons/sendEmail.svg?component'
import requestText from './icons/requestText.svg?component'
import requestFile from './icons/requestFile.svg?component'
import paste from './icons/paste.svg?component'
import closeButtonBold from './icons/closeButtonBold.svg?component'
import closeButton from './icons/closeButton.svg?component'
import error from './icons/error.svg?component'
import infoOutline from './icons/infoOutline.svg?component'
import success from './icons/success.svg?component'
import chat from './icons/chat.svg?component'
import photo from './icons/photo.svg?component'
import skipTime from './icons/skipTime.svg?component'
import stack from './icons/stack.svg?component'
import playOutline from './icons/playOutline.svg?component'
import alert from './icons/alert.svg?component'
import crossInCircle from './icons/crossInCircle.svg?component'
import definiteDeadEnd from './icons/definiteDeadEnd.svg?component'
import possibleDeadEnd from './icons/possibleDeadEnd.svg?component'
import info from './icons/info.svg?component'
import moreVertical from './icons/moreVertical.svg?component'
import moreVerticalBold from './icons/moreVerticalBold.svg?component'
import moreHorizontalBold from './icons/moreHorizontalBold.svg?component'
import chevronDown from './icons/chevronDown.svg?component'
import chevronUp from './icons/chevronUp.svg?component'
import chevronRight from './icons/ChevronRight.svg?component'
import upload from './icons/upload.svg?component'
import arrowUp from './icons/ArrowUp.svg?component'
import storagesDock from './icons/storagesDock.svg?component'
import doubleArrows from './icons/doubleArrows.svg?component'
import alertWarning from './icons/alertWarning.svg?component'
import search from './icons/search.svg?component'
import sort from './icons/sort.svg?component'
import warning from './icons/warning.svg?component'
import filter from './icons/filter.svg?component'
import folder from './icons/folder.svg?component'
import refresh from './icons/refresh.svg?component'
import visitStatistics from './icons/visitStatistics.svg?component'
import visitStatisticsDisabled from './icons/visitStatisticsDisabled.svg?component'
import exitStatistics from './icons/exitStatistics.svg?component'
import note from './icons/note.svg?component'

export type IconName = keyof typeof svgIcons

export const svgIcons = {
  note,
  radioButtonSelected,
  radioButton,
  refresh,
  play,
  logo,
  menu,
  infoFill,
  dialogue,
  collectUserData,
  condition,
  filter,
  folder,
  dialogueWithTimeout,
  integration,
  message,
  messageWithButtons,
  messageWithConfirmation,
  triggerAction,
  sendEmail,
  requestText,
  requestFile,
  paste,
  closeButtonBold,
  closeButton,
  error,
  infoOutline,
  success,
  chat,
  photo,
  skipTime,
  stack,
  playOutline,
  alert,
  crossInCircle,
  definiteDeadEnd,
  possibleDeadEnd,
  info,
  moreVertical,
  moreVerticalBold,
  moreHorizontalBold,
  chevronDown,
  chevronUp,
  chevronRight,
  upload,
  arrowUp,
  storagesDock,
  alertWarning,
  search,
  sort,
  warning,
  user,
  cog,
  ai,
  visitStatistics,
  visitStatisticsDisabled,
  exitStatistics,
  doubleArrows
}
